export default __webpack_public_path__ + "static/media/home-branding-agency-img-02.0835dbef.jpg";